export default angular.module('contartemx.onboarding', [])
    .factory('onboarding', ($state, $q, $timeout, $rootScope) => {

        let transitionTo = (route) => {
            return () => $state.transitionTo(route);            
        };

        let waitForTransition = function () {
            let deferred = $q.defer();
            $timeout(deferred.resolve, 250);
            return deferred.promise;
        };

        let PASOS = {
            'bienvenida': {
                title: "Bienvenido a contarte!",
                position: "centered",
                description: "Antes de poder trabajar, necesita completar algunos pasos. ¿Desea empezar?",
                width: 300,
                showButtons: true,
                actionNext: waitForTransition,
            },
            'preferencias': [{
                title: "Inicio",
                position: "bottom",
                description: "Haz click en Inicio.",
                attachTo: "#btnInicio",
                actionNext: waitForTransition,
                actionPrev: transitionTo('inicio.resumen'),
            },
            {
                id: "inicio.resumen",
                title: "1/4: Datos de perfil",
                position: "bottom",
                description: "Haz click en Preferencias.",
                attachTo: "#btnPreferencias",
                actionNext: transitionTo('preferencias.perfil'),
                actionPrev: transitionTo('inicio.resumen'),
                            }
            ],
            'preferencias.perfil':
                {
                    title: "1/4: Datos de perfil",
                    position: "top",
                    description: "Llena los datos faltantes: Nombre, RFC y dirección. Luego haz click en Guardar.",
                    attachTo: ".detail-view",
                    actionPrev: transitionTo('inicio.resumen'),
                },
            'preferencias.impuestos': [
                {
                    id: "preferencias.impuestos",
                    title: "2/4: Datos de impuestos ",
                    position: "right",
                    description: "Haz click en Impuestos. ",
                    attachTo: "#btnPrefImpuestos",
                    actionNext: transitionTo('preferencias.impuestos'),
                },
                {
                    id: "preferencias.pantalla.impuestos",
                    title: "2/4: Datos de impuestos",
                    position: "top",
                    description: "Selecciona los impuestos aplicables y haz click en Guardar.",
                    attachTo: ".detail-view",
                    actionPrev: transitionTo('preferencias.perfil'),
                },
            ],
            'preferencias.certificados': [
                {
                    title: "3/4: Certificado de timbres.",
                    position: "right",
                    description: "Haz click en Certificados.",
                    attachTo: "#btnPrefCertificados",
                    actionNext: transitionTo('preferencias.certificados'),
                    actionPrev: transitionTo('inicio.resumen'),
                },
                {
                    id: 'preferencias.boton.nuevoCertificado',
                    title: "3/4: Agrega tu certificado.",
                    position: "top",
                    description: "Haz click en agregar certificado. ",
                    attachTo: ".detail-view",
                    showButtons: false,
                    actionNext: waitForTransition,
                },
                {
                    id: 'preferencias.modal.nuevoCertificado',
                    title: "3/4: Agrega tu certificado.",
                    position: "top",
                    description: "Agrega los datos y selecciona o arrastra los archivos (.XSD y .KEY). Haz click en Cancelar para saltar este paso.",
                    attachTo: ".detail-view",
                    showButtons: false,
                    actionNext: waitForTransition,
                }
            ],
            'bancos.cuentas_bancarias': [
                 {
                     id: 'bancos.cuentas_bancarias',
                     title: "4/4: Alta de banco",
                     position: "bottom",
                     description: "Haz click en Bancos.",
                     attachTo: "#btnBancos",
                     actionNext: transitionTo('bancos.cuentas_bancarias'),
                     actionPrev: transitionTo('preferencias.perfil'),
                     showButtons: false,
                 },
                 {
                     id: "bancos.cuentasBancarias",
                     title: "4/4: Nuevo banco",
                     position: "bottom",
                     description: "Haz click en Nuevo Banco.",
                     attachTo: "#btnBancosNuevaCuenta",
                     showButtons: false,
                     actionNext: waitForTransition,
                 },
                 {
                     id: 'bancos.modal.nuevaCuenta',
                     title: "4/4: Datos de nuevo banco",
                     position: "top",
                     description: "Llena la forma con los datos del banco.",
                     attachTo: ".modal",
                     showButtons: false,
                 }
            ],
            'fin': {
                id: 'last',
                title: "Ha terminado!",
                position: "centered",
                description: "Ha concluido la configuración.<br /> No olvides descargar la <a href='https://chrome.google.com/webstore/detail/descarga-masiva-contarte/focolbbdepmjfopnpmgpeloejmdgnaoo' target='_blank'>Extension de Chrome </a> para descargar facturas del SAT.",
                showButtons: false,
            }
        };

        let onboardingSteps = [
            PASOS['bienvenida'],
            PASOS['preferencias'],
            PASOS['preferencias.perfil'],
            PASOS['preferencias.impuestos'],
            PASOS['preferencias.certificados'],
            PASOS['bancos.cuentas_bancarias'],
            PASOS['fin']
        ];
        
        let srv = {
            enabled: false,
            visto: false,
            callback() {
                srv.visto = true;
            },
            steps: [].concat.apply([], onboardingSteps),
            changeSteps (onboardSteps) {

                  if (angular.isNumber(onboardSteps) && onboardSteps < 15) {
                      let newSteps = [PASOS['bienvenida']];
                      let pasos = ('0000' + onboardSteps.toString(2)).slice(-4);
  
                      if (pasos[3] === '0' || pasos[2] === '0' || pasos[1] === '0') {
                          newSteps.push(PASOS['preferencias']);
                      }
                      if (pasos[3] === '0') {
                          newSteps.push(PASOS['preferencias.perfil']);
                      }
                      if (pasos[2] === '0') {
                          newSteps.push(PASOS['preferencias.impuestos']);
                      }
                      if (pasos[1] === '0') {
                          newSteps.push(PASOS['preferencias.certificados']);
                      }
                      if (pasos[0] === '0') {
                          newSteps.push(PASOS['bancos.cuentas_bancarias']);
                      }

                      newSteps.push(PASOS['fin']);
                      srv.steps.length = 0;
                      srv.steps = srv.steps.concat.apply([], newSteps);
                  }
            },
        };

        return srv;

    });
